const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'option',
    'label',
    '[role="button"]',
    '[role="combobox"]',
    '[role="menuitem"]',
    '[role="listbox"]',
    '[role="option"]',
    '[contenteditable="true"]',
    '.MuiButtonBase-root',
    '.rc-select',
    '.rc-select-dropdown',
    '.dossier-inline-edit',
    '[data-cell-inline-action]',
].join(', ')

export const isInteractiveClick = (event: {
    target: EventTarget | null
}): boolean => {
    const target = event.target
    return (
        target instanceof Element &&
        Boolean(target.closest(INTERACTIVE_SELECTOR))
    )
}
